import { DashboardContent } from "@/components/dashboard/DashboardContent";

export default function Dashboard() {
  return <DashboardContent />;
}